<template>
    <card-grid-item
        :tab-widget="tabWidget"
        :card-class="['card-grid']"
        :min-w="3"
        :min-h="minHeight"
        :resized="handleResized"
        @tab-widget-settings-click="handleTabWidgetSettingsClick"
    >
        <template v-slot:card-title>
            {{ title }}
        </template>
        <template v-slot:card-body>
            <card-grid
                ref="grid"
                :key="cardGridKey"
                :is-search="false"
                :columnDefs="columnDefs"
                :fetch-callback="fetchCallback"
                :pagination="true"
                :pagination-page-size="limit"
                :cache-block-size="limit"
                :font-size="tabWidget.settings.table_font_size"
            ></card-grid>
        </template>
        <template v-slot:tab-widget-settings-modal>
            <tab-widget-settings-modal-form
                :modal-id="tabWidgetSettingsModalID"
                :update="updateTabWidgetSettings"
                :initial-values="tabWidgetSettingsInitialValues"
                @success-update="handleSuccessTabWidgetSettingsUpdate"
                :withTableFontSize="true"
            ></tab-widget-settings-modal-form>
        </template>
    </card-grid-item>
</template>

<script>
    import API from '../../../../api';
    import CardGrid from '../../../generic/card-grid/card-grid.vue';
    import CardGridItem from '../common/card-grid-item.vue';
    import { getWidgetGridRowsNumber } from '../helpers';
    import { ICALENDAR_SYNC_LOGS_GRID_ENDPOINT } from '../../../../endpoints';
    import TabWidgetSettingsModalForm from '../common/tab-widget-settings-modal-form.vue';
    import cardGridItemBaseMixin from '../common/card-grid-item-base-mixin';

    export default {
        name: 'ICalendarConflictsTableCardGridItem',
        mixins: [cardGridItemBaseMixin],

        components: {
            CardGrid,
            CardGridItem,
            TabWidgetSettingsModalForm,
        },
        computed: {
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;
                    return API.get(ICALENDAR_SYNC_LOGS_GRID_ENDPOINT(), {
                        params: {
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                            conflicts: true,
                            errors: true,
                        },
                    });
                };
            },
            tabWidgetSettingsInitialValues() {
                return {
                    settings: {
                        name: this.tabWidget.settings.name || this.defaultName,
                        table_font_size: this.tabWidget.settings.table_font_size || this.defaultWidgetFontSize,
                    },
                };
            },
        },
        data() {
            return {
                columnDefs: [
                    {
                        field: 'id',
                        hide: true,
                    },
                    {
                        field: 'created',
                        headerName: 'Timestamp',
                        type: 'dateTimeColumn',
                        sort: 'desc',
                        minWidth: 200,
                    },
                    {
                        field: 'rental_property.name',
                        headerName: 'Property',
                    },
                    {
                        field: 'icalendar.url',
                        headerName: 'iCal URL',
                    },
                    {
                        field: 'import_from_date',
                        headerName: 'Import From Date',
                        minWidth: 150,
                    },
                    {
                        field: 'import_to_date',
                        headerName: 'Import To Date',
                        minWidth: 150,
                    },
                    {
                        field: 'conflict_from_date',
                        headerName: 'Conflict From Date',
                        minWidth: 150,
                    },
                    {
                        field: 'conflict_to_date',
                        headerName: 'Conflict To Date',
                        minWidth: 150,
                    },
                    {
                        field: 'line',
                        headerName: 'Message',
                    },
                ],
                offset: 0,
                limit: getWidgetGridRowsNumber({ tabWidget: this.tabWidget }),
                sort: 'id',
                desc: false,
                search: '',
            };
        },
        methods: {
            handleResized() {
                this.limit = getWidgetGridRowsNumber({ tabWidget: this.tabWidget });
                this.cardGridKey += 1;
            },
        },
    };
</script>

<style lang="scss" scoped>
    :deep(.ag-header-cell-text) {
        white-space: nowrap !important;
    }
</style>
